import { render, staticRenderFns } from "./2025gitex.vue?vue&type=template&id=d8d068c4&scoped=true&"
import script from "./2025gitex.vue?vue&type=script&lang=js&"
export * from "./2025gitex.vue?vue&type=script&lang=js&"
import style0 from "./2025gitex.vue?vue&type=style&index=0&id=d8d068c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d068c4",
  null
  
)

export default component.exports